import React from 'react';
import HeaderNonSrp from '../header/headerNonSrp';
import SubHeader from '../header/subHeader';
import Footer from '../footer/footer';
import CancelDetails from '../cancel/cancelDetails';
const GuestCancelConfirm = () => {
    const params = new URLSearchParams(window.location.search);
    console.log("param", params.get('pnr'));
    const pnr = params.get('pnr');
    const mobile = params.get('mobile');
    return (
        <div style={{ backgound: '#ccc' }}>
            <HeaderNonSrp />
            <SubHeader />
            <div style={{ padding: '20px 6%' }}>
                {
                    pnr &&
                    <CancelDetails pnr={pnr} guestCancel={true} mobile={mobile} />
                }
            </div>
            <Footer />
        </div>
    )
}

export default GuestCancelConfirm;
